export default "__VITE_ASSET__CXfSUAOq__"